import React from 'react';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import './FullHeight.scss';
const FullHeight = () => {
  return (
    <Container maxWidth="experiment-height xl">
      <Paper className="paper-container">
        <main className="container card full-height white">
          <section className="card__header"></section>
          <section className="card__body"></section>
          <section className="card__footer"></section>
        </main>
      </Paper>
    </Container>
  );
};

export default FullHeight;
